import NewInsuranceBlock from "components/addInsuranceBlock/AddInsuranceBlock";
import React from "react";

function InsuranceOption({
  onClickAddInsurance,
  isInsuranceExpired,
  isActive,
  insurance_details,
  onClick,
  selectCash,
  onClickUpdateInsurance,
  disabled,
  loading,
  showConfirm = () => {},
  checkingInsuranceInNetwork,
  insuranceInNetwork,
  currentPatient,
  speciality,
}) {
  // Out-of-network check no longer forces selection; allow user to proceed with insurance.

  if (insurance_details?.insurance_company) {
    return (
      <NewInsuranceBlock
        insuranceDetails={insurance_details}
        isExpired={isInsuranceExpired}
        isLoading={loading}
        isActive={isActive}
        disabled={isInsuranceExpired}
        onInsuranceClick={() => {
          if (isInsuranceExpired || disabled) {
            return null;
          } else {
            onClick("insurance");
            showConfirm();
          }
        }}
        onUpdateInsurance={onClickUpdateInsurance}
        disabledReason={`Depending on your insurance, co-pays and co-insurances may apply. We make an effort to verify whether we are in-network with your insurance; however, you should contact your insurance carrier directly to confirm whether SkyMD is in-network.`}
        onAddSecondaryInsurance={() => onClickUpdateInsurance(2, true)}
        onUpdateSecondaryInsurance={() => onClickUpdateInsurance(2, true)}
      />
    );
  } else {
    return (
      <NewInsuranceBlock
        isActive={isActive}
        onInsuranceClick={onClickAddInsurance}
      />
    );
  }
}

export default InsuranceOption;
